let element = null;

function ensureElement() {
  if (element) return element;
  element = document.createElement("div");
  element.setAttribute("aria-live", "polite");
  element.setAttribute("aria-atomic", "true");
  element.className = "sr-only";
  document.body.appendChild(element);
  return element;
}

export function announce(message) {
  if (!message) return;
  const el = ensureElement();
  el.textContent = "";
  setTimeout(() => {
    el.textContent = message;
  }, 50);
}
